import { ReactElement } from 'react';
import { TableTopNotificationProps } from './TableTopNotification';

export type TopNotificationBasicRenderProp =
  | ReactElement<TableTopNotificationProps>
  | (() => ReactElement<TableTopNotificationProps> | boolean | null | undefined)
  | boolean
  | null
  | undefined;
